// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"108":"e574b131ecb3f8f2ebb7","245":"52980ece668e8bf549de","452":"7ed8b3036c0e1de8da32","453":"9a0652cb8a6aaa52699b"}[chunkId] + ".js";
};